import React, { useState, Fragment, Component } from 'react';
import './style.scss';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import { Alert, Table, notification } from 'antd';
import { PropTypes } from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import EinvoiceEwaybillIntegrationActions from '@Actions/integrations/einvoiceEwaybillActions';
import UserActions from '@Actions/userActions';
import ewayEmptyState from '@Images/eway-bill-empty.png';

const EwaybillEnable = ({
  user, enableEinvoiceEwaybill, getUserProfile, updateLogin,
}) => {
  const data = [
    {
      key: '1',
      revenue: 500,
      date: '01/10/2020',
    },
    {
      key: '2',
      revenue: 100,
      date: '01/10/2021',
    },
    {
      key: '3',
      revenue: 50,
      date: '01/04/2021',
    },
    {
      key: '4',
      revenue: 20,
      date: '01/04/2022',
    },
    {
      key: '5',
      revenue: 10,
      date: '01/10/2022',
    },
  ];

  const columns = [
    {
      title: 'BUSINESS TURNOVER',
      dataIndex: 'revenue',
      render: (text) => <div>{`Revenue > ${text} crores`}</div>,
    },
    {
      title: 'START DATE',
      dataIndex: 'date',
      render: (text) => <div>{`Any date after ${text}`}</div>,
      align: 'right',
    },
  ];
  return (
    <div className="view-einvoicing__wrapper">
      <div className="center" style={{ display: 'flex', flexDirection: 'column' }}>
        <H3Image src={ewayEmptyState} className="ewaybill__image" />
        <div className="text-content">
          Connect Procuzy with the e-Way Bill portal
        </div>
        <H3Text
          text={(
            <div>
              Before you can connect Procuzy with e-Way Bill portal, you need the Username and Password generated by registering&nbsp;
              <a href="https://webtel.in/index.aspx" target="_blank" rel="noreferrer">Webtel Electrosoft Private Limited</a>
              &nbsp;
              as your GST Suvidha Provider in the e-Way Bill portal.
            </div>
          )}
          className="text-description"
        />
        <H3Button
          text="Connect Now"
          customClass="einvoicing__button"
          onClick={() => updateLogin(true)}
        />
      </div>
    </div>
  );
};
const mapStateToProps = ({ EinvoiceEwaybillReducers }) => ({
  enableEinvoiceEwaybillLoading: EinvoiceEwaybillReducers.enableEinvoiceEwaybillLoading,
});

const mapDispatchToProps = (dispatch) => ({
  enableEinvoiceEwaybill: (payload, callback) => dispatch(EinvoiceEwaybillIntegrationActions.enableEinvoiceEwaybill(payload, callback)),
  getUserProfile: () => dispatch(UserActions.getUserProfile()),
});

EwaybillEnable.propTypes = {
  user: PropTypes.any,
  enableEinvoiceEwaybill: PropTypes.func,
  getUserProfile: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(EwaybillEnable));
